import { WalletController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import { NewBeneficiary } from '../../pages';
import constant from '../../utils/constant';
import { useStores } from '../../stores';
import React, { useState } from 'react';
import * as yup from 'yup';

const NewBeneficiaryContainer = ({
	goToBankList,
	selectedState,
	transferSwitchState,
	stage2,
	setStage2,
}) => {
	const { walletStore } = useStores();
	const [loading, setLoading] = useState(false);

	const validationSchema = () => {
		return yup.object({
			transactionAmount: yup
				.number()
				.min(100, 'Amount Should be greater than 100.00'),
			beneficiaryBank: yup.string().required('Beneficiary Bank is required'),
			beneficiaryAccountNumber: yup
				.string()
				.required('Account Number is required'),
			narration: yup.string().required('Description is required'),
			expenseCategory: yup.string().required('Expense Category is required'),
		});
	};

	const onSubmit = payload => {
		//to be gotten from the ui
		// payload.saveBeneficiary = true;

		if (payload.nickName === '') {
			delete payload.nickName;
		}

		walletStore.setTransferPayload(payload);
		return transferSwitchState.goToConfirmPin();
	};

	const verifyAccountNumber = async payload => {
		if (
			payload.beneficiaryBank &&
			payload.accountNumber &&
			payload.accountNumber.length === 10
		) {
			const { status, data, errorMessage } =
				await WalletController.verifyAccountNumber(payload);
			if (status === constant.Success) {
				return data.accountName;
			} else {
				MimaToastUtil.error({
					message: errorMessage,
				});
			}
		}
		return '';
	};

	return (
		<NewBeneficiary
			setLoading={setLoading}
			loading={loading}
			verifyAccountNumber={verifyAccountNumber}
			validationSchema={validationSchema}
			goToBankList={goToBankList}
			onSubmit={onSubmit}
			selectedState={selectedState}
			stage2={stage2}
			setStage2={setStage2}
		/>
	);
};

export default NewBeneficiaryContainer;
